module.exports = __webpack_public_path__ + "static/media/promote.3688af9a.gif";